module.exports = __webpack_public_path__ + "img/extra2.b87cccfa.jpg";